import {Injectable} from '@angular/core';
import {ApiWebService} from '../../shared/@types';
import {Utente} from '../@types';
import {map} from 'rxjs';
import {normalizeUtente} from '../../shared/custom-operators/custom.operators';

@Injectable({
  providedIn: 'root'
})
export class UtentiService extends ApiWebService {

  constructor() {
    super('utenti');
  }

  getUtenti$() {
    return this.get$<Utente[]>({}, 'utenti').pipe(
      map(res => res)
    );
  }

  salvaUtente$(utente: Utente, mode: 'insert' | 'update') {
    if (mode === 'update') {
      return this.put$<Utente>(utente.id, utente, 'utenti').pipe(
        normalizeUtente()
      );
    } else {
      return this.post$<Utente>(utente, 'utenti').pipe(
        normalizeUtente()
      );
    }
  }

}
